import type { ResendNotificationInput, ResendNotificationResult } from '@repo/api-contracts';
import { useInvalidateNotifications } from '@/entities/notification';
import { trpc } from '@/shared/api';

/**
 * 알림 재발송(notificationManagement.resendDelivery, 알림 설계 §5-3). 성공하면 발송 이력 목록을 다시 불러와 새 "대기" 행이 보이게 하고
 * 새 기록 id 를 돌려준다. 실패하면 서버 오류를 그대로 던진다. 문구는 재발송 대화상자(OrderActionDialog)가 보인다.
 */
export const useResendNotification = (): ((
  input: ResendNotificationInput,
) => Promise<ResendNotificationResult>) => {
  const notifications = useInvalidateNotifications();
  const mutation = trpc.notificationManagement.resendDelivery.useMutation();

  return async (input) => {
    const result = await mutation.mutateAsync(input);
    await notifications.invalidateDeliveries();
    return result;
  };
};
